import "./footer.css";
import "../../App.css";

function Footer() {
    return (
        <footer id="footer" class="footer white">
            <div class="container">
                <h2 class="ir_so">푸터 바로가기 메뉴</h2>
                <div class="footer_menu">
                    <div class="footer_type1">
                        <h3>레이아웃 영역</h3>
                        <ul>
                            <li>
                                <a href="#">레이아웃 유형01</a>
                            </li>
                            <li>
                                <a href="#">레이아웃 유형02</a>
                            </li>
                            <li>
                                <a href="#">레이아웃 유형03</a>
                            </li>
                            <li>
                                <a href="#">레이아웃 유형04</a>
                            </li>
                            <li>
                                <a href="#">레이아웃 유형05</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer_type2">
                        <h3>게시판 영역</h3>
                        <ul>
                            <li>
                                <a href="../board/board.php">게시판</a>
                            </li>
                            <li>
                                <a href="../board/boardModify.php">게시판 수정하기</a>
                            </li>
                            <li>
                                <a href="../board/boardView.php">게시판 보기</a>
                            </li>
                            <li>
                                <a href="../board/boardWrite.php">게시글 쓰기</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer_type3">
                        <h3>게시판 영역</h3>
                        <ul>
                            <li>
                                <a href="../board/board.php">게시판</a>
                            </li>
                            <li>
                                <a href="../board/boardModify.php">게시판 수정하기</a>
                            </li>
                            <li>
                                <a href="../board/boardView.php">게시판 보기</a>
                            </li>
                            <li>
                                <a href="../board/boardWrite.php">게시글 쓰기</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer_type4">
                        <h3>컨텐츠 영역</h3>
                        <ul>
                            <li>
                                <a href="#">텍스트 유형01</a>
                            </li>
                            <li>
                                <a href="#">이미지 유형02</a>
                            </li>
                            <li>
                                <a href="#">이미지/텍스트03</a>
                            </li>
                            <li>
                                <a href="#">카드 유형04</a>
                            </li>
                            <li>
                                <a href="#">배너 유형05</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer_type5">
                        <h3>푸터 영역</h3>
                        <ul>
                            <li>
                                <a href="#">컨택트 유형01</a>
                            </li>
                            <li>
                                <a href="#">푸터 유형01</a>
                            </li>
                        </ul>
                    </div>
                    <div class="footer_type6">
                        <h3>사이트</h3>
                        <ul>
                            <li>
                                <a href="#">웹표준 사이트</a>
                            </li>
                            <li>
                                <a href="#">반응형 사이트</a>
                            </li>
                            <li>
                                <a href="#">패럴랙스 사이트</a>
                            </li>
                            <li>
                                <a href="#">포트폴리오 사이트</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <address class="footer_rights">&copy;2022 All rights reserved.</address>
            </div>
        </footer>
    );
}

export default Footer;
